/* eslint-disable no-underscore-dangle */
import { createSelector } from 'reselect';

export const getVideo = (state) => state.video;
export const getForm = (state) => state.form;
export const getFocusAreaVideo = (state) => state.video.focusAreas;
export const getEquipmentVideo = (state) => state.video.equipments;

export const isVideoLoading = createSelector(
  getVideo,
  (video) => video.loading
);

// Search results carry copies of the focus area and equipment taken when the
// video was saved. Prefer the current category documents so renamed categories
// show their current name, keeping the saved copy until the categories load.
export const getVideos = createSelector(
  getVideo,
  getFocusAreaVideo,
  getEquipmentVideo,
  (video, focusAreas, equipments) =>
    video.videos.map((item) => ({
      ...item,
      focus_area:
        focusAreas.find(({ _id }) => _id === item.focus_area?._id) ??
        item.focus_area,
      equipment:
        equipments.find(({ _id }) => _id === item.equipment?._id) ??
        item.equipment,
    }))
);

// False until the first search settles, whatever it returned
export const areVideosFetched = createSelector(
  getVideo,
  (video) => video.videosFetched
);

export const getVideosError = createSelector(
  getVideo,
  (video) => video.videosError
);

export const getVideosTotalAmount = createSelector(
  getVideo,
  (video) => video.videosTotalAmount
);

export const getFocusAreas = createSelector(getFocusAreaVideo, (focusArea) =>
  focusArea.slice().sort((a, b) => a.name.localeCompare(b.name))
);

export const getEquipments = createSelector(getEquipmentVideo, (video) =>
  video.slice().sort((a, b) => a.name.localeCompare(b.name))
);

export const getPagination = createSelector(
  getVideo,
  (video) => video.pagination
);

export const getSearchVideosTerm = createSelector(
  getVideo,
  (video) => video.search.term
);

export const getSearchVideosEquipment = createSelector(
  getVideo,
  (video) => video.search.equipment
);

export const getSearchVideosFocusArea = createSelector(
  getVideo,
  (video) => video.search.focusArea
);

export const getSelectedVideoCard = createSelector(
  getVideo,
  ({ videoCard }) => videoCard
);

export const getSelectedVideo = createSelector(
  getForm,
  (form) => form['select-video']?.values?.videoElement
);

export const getEditVideoFocusArea = createSelector(
  getForm,
  (form) => form['edit-video']?.values?.focusArea
);
export const getEditVideoEquipment = createSelector(
  getForm,
  (form) => form['edit-video']?.values?.equipment
);

export const getSelectedDateRange = createSelector(
  getVideo,
  (video) => video.search.dateRange
);
